import React from "react";
import { useTranslation } from "react-i18next";

import { toFixed } from "../utils";
import { Props } from "./types";
import styles from "./styles.scss";
import { AllocationUnit } from "@common/allocationUnit";

function Stats({ synthesis }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.stats}>
      <div className={styles.col}>
        <div className={styles.row}>
          <p className={styles.label}>
            {t("projectPage.synthesisPage.monitoring.allocatedTime")}
          </p>
          <p className={styles.value}>
            {toFixed(synthesis.allocatedTime)} <AllocationUnit />
          </p>
        </div>
        <div className={styles.row}>
          <p className={styles.label}>
            {t("projectPage.synthesisPage.monitoring.workedHours")}
          </p>
          <p className={styles.value}>
            {toFixed(synthesis.totalOfTimesSpentInProject)} <AllocationUnit />
          </p>
        </div>
        <div className={styles.row}>
          <p className={styles.label}>
            {t("projectPage.synthesisPage.monitoring.openedWorkHours")}
          </p>
          <p className={styles.value}>
            {toFixed(synthesis.totalOfRemainingTimeInProject)}{" "}
            <AllocationUnit />
          </p>
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.row}>
          <p className={styles.label}>
            {t("projectPage.synthesisPage.monitoring.doneMilestones")}
          </p>
          <p className={styles.value}>
            {synthesis.doneMilestonesNbr} / {synthesis.milestonesNbr}
          </p>
        </div>
        <div className={styles.row}>
          <p className={styles.label}>
            {t("projectPage.synthesisPage.monitoring.doneTasks")}
          </p>
          <p className={styles.value}>
            {synthesis.doneTasksNbr} / {synthesis.tasksNbr}
          </p>
        </div>
      </div>
    </div>
  );
}

export { Stats };
